export const preferencesPtBr = {
  title: 'Preferências',
  subtitle: 'Personalize sua experiência no sistema',
  languageRegion: {
    title: 'Idioma e Região',
    description: 'Configure o idioma da interface e o formato de exibição de números e datas',
    language: {
      label: 'Idioma da interface',
      helper: 'Define o idioma dos menus, botões e mensagens do sistema',
    },
    locale: {
      label: 'Formato regional',
      helper: 'Define como números, moedas e datas são exibidos',
    },
    dateFormat: {
      label: 'Formato de data',
      short: 'Curto',
      medium: 'Médio',
      long: 'Completo',
    },
  },
  appearance: {
    title: 'Aparência',
    description: 'Escolha o tema visual do sistema',
    theme: {
      label: 'Tema',
      light: 'Claro',
      dark: 'Escuro',
      system: 'Sistema',
      currentSystem: 'Tema atual do sistema:',
      toggle: 'Alternar tema claro/escuro',
    },
  },
  reset: {
    title: 'Restaurar padrões',
    description:
      'Restaura todas as preferências para as configurações detectadas do navegador/sistema',
    button: 'Restaurar configurações do sistema',
  },
  languages: {
    'pt-BR': 'Português (Brasil)',
    'en-US': 'English (US)',
  },
  locales: {
    'pt-BR': 'Brasil (R$ 1.234,56 / 31/12/2026)',
    'en-US': 'United States ($1,234.56 / 12/31/2026)',
  },
};

export const preferencesEn = {
  title: 'Preferences',
  subtitle: 'Customize your system experience',
  languageRegion: {
    title: 'Language & Region',
    description: 'Configure interface language and number/date display format',
    language: {
      label: 'Interface language',
      helper: 'Sets the language for menus, buttons, and system messages',
    },
    locale: {
      label: 'Regional format',
      helper: 'Sets how numbers, currencies, and dates are displayed',
    },
    dateFormat: {
      label: 'Date format',
      short: 'Short',
      medium: 'Medium',
      long: 'Full',
    },
  },
  appearance: {
    title: 'Appearance',
    description: 'Choose the visual theme',
    theme: {
      label: 'Theme',
      light: 'Light',
      dark: 'Dark',
      system: 'System',
      currentSystem: 'Current system theme:',
      toggle: 'Toggle light/dark theme',
    },
  },
  reset: {
    title: 'Reset to defaults',
    description: 'Restores all preferences to browser/system detected settings',
    button: 'Restore system settings',
  },
  languages: {
    'pt-BR': 'Português (Brasil)',
    'en-US': 'English (US)',
  },
  locales: {
    'pt-BR': 'Brasil (R$ 1.234,56 / 31/12/2026)',
    'en-US': 'United States ($1,234.56 / 12/31/2026)',
  },
};
